// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__30Wuf","clinicsSelect":"TableHeading_clinicsSelect__1ry3J"};